import React, { useState } from 'react';
import axios from 'axios';
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
} from 'reactstrap';
import GetRequestComponent from '../../../components/Common/GetRequest';
const GetAllMembership = () => {
    const [url, setUrl] = useState('');
    const [requestBody, setRequestBody] = useState('');
    const [response, setResponse] = useState(null);
    const [breadcrumbItems] = useState([
      { title: 'Membership', link: '#' },
      { title: 'Get All Membership', link: '#' }
    ]);
    const handleSendRequest = async () => {
      try {
        const response = await axios.post(url, JSON.parse(requestBody));
        setResponse(response.data);
      } catch (error) {
        setResponse(error.message);
      }
    };
    const headers=[
      {
        title:'apikey',
        type:'text',
        required:true,
      }
    ]
    const queryparams=[
      {
        title:'membership_type',
        type:'dropdown',
        options:[{label:'past',value:'past'},{label:'current',value:'current'},{label:'upcoming',value:'upcoming'},{label:'not_approved',value:'not_approved'}]
      },
      {
        title:'page',
        type:'text',
      },
      {
        title:'limit',
        type:'text',
      }
    ]
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
        <Breadcrumbs
            title="Get All Membership"
            breadcrumbItems={breadcrumbItems}
          />
          <p>To Get all Memberships Purchased by the Shop. Fields marked with <span style={{color:"red"}}>*</span> are required</p>
      <GetRequestComponent title="Get All Membership" headers={headers}  queryparams={queryparams} url='/v2/tp/membership'/>
      </Container>
      </div>
    </React.Fragment>
  )
}

export default GetAllMembership